import { ONE_HOUR } from 'src/shared/constants/times';

const TWO_HOURS_MS = ONE_HOUR * 2 * 1000;

export const defaultQueryOptions = {
  cacheTime: TWO_HOURS_MS,
  staleTime: TWO_HOURS_MS,
};
